var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "511pt",
    viewBox: "-13 1 511 511.99998",
    width: "511pt",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m486.050781 407.066406-64.378906-9.152344-28.402344-56.175781-28.398437 56.175781-46.597656 6.625-46.59375-6.625-28.402344-56.175781-28.402344 56.175781-46.597656 6.625-46.59375-6.625-28.402344-56.175781-28.402344 56.175781-64.378906 9.152344 46.609375 44.355469-10.914063 60.578125 57.085938-27.765625 57.082031 27.75-10.914062-60.5625 28.828125-27.429687 28.828125 27.429687-10.914063 60.578125 57.082032-27.765625 57.085937 27.75-10.914063-60.5625 28.828126-27.429687 28.828124 27.429687-10.914062 60.578125 57.082031-27.765625 57.085938 27.75-10.914063-60.5625zm0 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m348.273438 254.992188c0-57.890626-47.109376-104.996094-105-104.996094-57.886719 0-104.996094 47.105468-104.996094 104.996094v75h209.996094zm0 0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m318.273438 74.996094c0-41.351563-33.648438-74.996094-75-74.996094-41.351563 0-74.996094 33.644531-74.996094 74.996094 0 41.351562 33.644531 75 74.996094 75 41.351562 0 75-33.648438 75-75zm0 0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClient);
export default __webpack_public_path__ + "static/media/client.db40535e2a50beb813e356d964d86c90.svg";
export { ForwardRef as ReactComponent };